import React, { Component } from 'react';
import './Avatar.scss';

export class Avatar extends Component {
    static displayName = Avatar.name;

    render() {
        return <img className="avatar" alt="" src={`/users/thumbnail?id=${this.props.user.id}`} title={ this.props.user.name } />;
    }
}